<template>
 <i-dropdown :item-count="listCount">
  <template #trigger="{ toggle, attrs }">
    <i-button
      ref="button"
      :disabled="disabled"
      :title="title"
      @click.prevent="toggle"
      v-bind="attrs"
      tabindex="-1"
    >
      <span class="tiptap-select-label">
        {{ this[selection]() || label || title }}
      </span>
      <i-icon icon="caret-down" :style="{ fontSize: '0.6em' }"></i-icon>
    </i-button>
  </template>

  <template #default="{ isOpen, close, activeIndex }">
    <ul
      v-if="isOpen"
      class="dropdown-menu i-dropdown-menu block"
      role="select"
    >
      <div class="pl2">{{ title }}</div>

      <li
        v-for="(item, index) in listItems"
        :key="index"
        :class="[
          'dropdown-item',
          { 'i-dropdown-item-selected': item.label === this[selection]() }
        ]"
        :aria-label="item.label"
        v-dropdown-focus="{ index, activeIndex }"
      >
        <a
          href="#"
          class="i-action-browse-by"
          :title="item.label"
          @click.prevent="() => method(item.method, item.options)"
          @keydown.enter.prevent="() => method(item.method, item.options)"
        >
          {{ item.label }}
        </a>
      </li>
    </ul>
  </template>
</i-dropdown>

</template>

<script>
import Button from '@/components/lib/button/Button.vue'
import Icon from '@/components/lib/icon/Icon.vue'
import Dropdown from '@/components/lib/dropdown/Dropdown.vue'

export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
  },
  props: {
    editor: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    title: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
    method: {
      type: Function,
      required: true,
    },
    selection: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    filtered: {
      type: Boolean,
    },
  },
  mounted() {
    this.$refs.button && (this.button = this.$refs.button.$el || this.$refs.button)
  },
  methods: {
    getSelectedNodeType() {
      return this.options.find(option =>
        this.editor.isActive(option.selectedNode, option.options)
      )?.label;
    },
    getSelectedStyles() {
      return this.options.find(option => 
        this.editor.isActive(option.options.element, option.options.attrs)
      )?.label;
    },
    getFontFamily() {
      const selectedFontFamily = this.editor.getAttributes('textStyle').fontFamily || null;

      // Find the label of the matching font family
      return this.options.find(
        (option) => option.options === selectedFontFamily
      )?.label || ''; // Fallback to 'Default' if no match    
    },
    getFontSize() {
      const selectedFontSize = this.editor.getAttributes('textStyle').fontSize || null;

      // Find the label of the matching font family
      return this.options.find(
        (option) => option.label === selectedFontSize
      )?.label || ''; // Fallback to 'Default' if no match    
    },
    format(val) {
      return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    },
  },
  computed: {
    listItems() {
      if (this.filtered) {
        return this.filterSelectedStyles;
      }

      return this.options;
    },
    listCount() {
      return this.listItems.length;
    },
    filterSelectedStyles() {
      return this.options.filter(option => this.editor.isActive(option.options.element));
    },
  },
}
</script>

<style lang="scss" scoped>
.tiptap-select-label {
  margin-right: 15px;



}

.i-dropdown-menu {
  display: block;
  overflow-y: auto;
  max-height: 200px;
  width: 120px;

  .pl2 {
    width: 100%;
    padding: 4px;
    padding-left: 14px;
    background-color: white;
    border-bottom: 1px solid gray;
  }
}
</style>
